import { render, staticRenderFns } from "./similarityAnalysis.vue?vue&type=template&id=6694184e&scoped=true"
import script from "./similarityAnalysis.vue?vue&type=script&lang=js"
export * from "./similarityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./similarityAnalysis.vue?vue&type=style&index=0&id=6694184e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6694184e",
  null
  
)

export default component.exports